import type { PdfComponent } from '../../TermsAndConditionsRender/components/typed';

export const SECTION25: PdfComponent = {
  type: 'section',
  id: 's25',
  title: '25. Force Majeure',
  content: [
    {
      type: 'bulletList',
      id: 's25bullets',
      bulletType: 'number',
      content: [
        {
          copy: 'A party shall not be liable if delayed in or prevented from performing its obligations under this Agreement due to a Force Majeure Event, provided that it:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'promptly notifies the other of the Force Majeure Event and its expected duration; and',
              },
              {
                copy: 'uses reasonable endeavours to minimise the effects of that event.',
              },
            ],
          },
        },
        {
          copy: 'If, due to a Force Majeure Event, a party:',
          sublist: {
            bulletType: 'alpha',
            content: [
              {
                copy: 'is or is likely to be unable to perform a material obligation; or',
              },
              {
                copy: 'is or is likely to be delayed in or prevented from performing its obligations for a continuous period of more than 21 Business Days,',
              },
            ],
          },
          subcopy:
            'then the unaffected party may terminate this Agreement on not less than 14 days’ written notice.',
        },
      ],
      prefix: '25',
    },
  ],
};
